/**
 * @description: 浏览器数据操作工具
 * @author: zb
 * @update: zb
 * @Date: 2019-07-03 11:05:34
 * @LastEditors: zb
 * @LastEditTime: 2019-07-03 14:12:16
 */
function compileStr(code) {
  var c = String.fromCharCode(code.charCodeAt(0) + code.length)
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1))
  }
  return escape(c)
}
// 字符串进行解密
function uncompileStr(code) {
  code = unescape(code)
  var c = String.fromCharCode(code.charCodeAt(0) - code.length)
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1))
  }
  return c
}

export const DatabaseUtil = function() {
  this.sessionStorageUtil = function() { }
  // sessionStorage 数据存储的操作
  this.sessionStorageUtil.set = function(key, val) {
    sessionStorage.setItem(compileStr(key), val)
  }
  this.sessionStorageUtil.get = function(key, val) {
    return sessionStorage.getItem(compileStr(key))
  }

  this.sessionStorageUtil.has = function(key) {
    return sessionStorage.getItem(compileStr(key)) !== null && sessionStorage.getItem(compileStr(key)) !== ''
  }

  this.localStorageUtil = function() { }
  this.localStorageUtil.set = function(key, val) {
    localStorage.setItem(compileStr(key), val)
  }
  this.localStorageUtil.get = function(key, val) {
    return localStorage.getItem(compileStr(key))
  }

  this.localStorageUtil.has = function(key) {
    return localStorage.getItem(compileStr(key)) !== null && localStorage.getItem(compileStr(key)) !== ''
  }
}
